export const iconFontAwesomeEnergyFan = (
	<i className="fa-solid fa-fan"></i>
);
